import Alert from "react-bootstrap/Alert";
import React from "react";
// import config from '../configs/config';
import i18next from "i18next";
import m from "moment";

export const default_error_message =
  "O servidor não conseguiu processar sua solicitação, por favor entre em contato com o suporte.";

export const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

export const getErrorComponent = (msg) => {
  return <Alert variant="danger">Erro : {i18next.t(msg)} </Alert>;
};

export const deltaDate = () => {
  var date = new Date();
  date.setDate(-1);
  return date;
};

export const formatTime = (time) => {
  let data = new Date(time),
    dia = data.getDate().toString(),
    diaF = dia.length === 1 ? "0" + dia : dia,
    mes = (data.getMonth() + 1).toString(),
    mesF = mes.length === 1 ? "0" + mes : mes,
    anoF = data.getFullYear(),
    hour = ("0" + data.getHours()).slice(-2).toString(),
    minutes = ("0" + data.getMinutes()).slice(-2).toString(),
    seconds = ("0" + data.getSeconds()).slice(-2).toString();

  return `${diaF}/${mesF}/${anoF} - ${hour}:${minutes}`; //  09/09/2000 -  12:54
};

export const formatRelativeTime = (timestamp, t) => {
  const translate =
    typeof t === "function"
      ? t
      : (key, opts) => {
          if (opts && opts.count != null) {
            return String(key).replace("{{count}}", String(opts.count));
          }
          return key;
        };

  const time = new Date(timestamp).getTime();
  if (!Number.isFinite(time)) return "";

  const diffInSeconds = Math.max(0, Math.floor((Date.now() - time) / 1000));

  if (diffInSeconds < 45) {
    return translate("há instantes");
  }
  if (diffInSeconds < 3600) {
    const minutes = Math.max(1, Math.floor(diffInSeconds / 60));
    if (minutes === 1) return translate("há 1 minuto");
    return translate("há {{count}} minutos", { count: minutes });
  }
  if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    if (hours === 1) return translate("há 1 hora");
    return translate("há {{count}} horas", { count: hours });
  }
  const days = Math.floor(diffInSeconds / 86400);
  if (days === 1) return translate("há 1 dia");
  return translate("há {{count}} dias", { count: days });
};

export const getFormatedDate = (dt) => {
  let data = new Date(dt),
    dia = dt.getDate().toString(),
    diaF = dia.length === 1 ? "0" + dia : dia,
    mes = (data.getMonth() + 1).toString(),
    mesF = mes.length === 1 ? "0" + mes : mes,
    anoF = data.getFullYear(),
    hour = ("0" + data.getHours()).slice(-2).toString(),
    minutes = ("0" + data.getMinutes()).slice(-2).toString(),
    seconds = ("0" + data.getSeconds()).slice(-2).toString();

  return (
    anoF + "-" + mesF + "-" + diaF + "T" + hour + ":" + minutes + ":" + seconds
  ); // 2020-02-05T12:54:00
};

/**
 * Converte Date do navegador (relógio local de quem está vendo) para UTC na API.
 */
export const localDateToApiUtcParam = (date) => {
  if (!date) return "";
  const parsed = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().replace(/\.\d{3}Z$/, "Z");
};

export const buildUtcRangeQueryParams = (startDate, endDate) => {
  const dt_ini = encodeURIComponent(localDateToApiUtcParam(startDate));
  const dt_end = encodeURIComponent(localDateToApiUtcParam(endDate));
  return `&dt_ini=${dt_ini}&dt_end=${dt_end}`;
};

export const buildUtcFromToParams = (startDate, endDate) => ({
  from: localDateToApiUtcParam(startDate),
  to: localDateToApiUtcParam(endDate),
});

/** Fuso IANA do navegador (ex.: America/Sao_Paulo). */
export const getViewerTimezoneLabel = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (_) {
    const offsetHours = -new Date().getTimezoneOffset() / 60;
    const sign = offsetHours >= 0 ? "+" : "";
    return `UTC${sign}${offsetHours}`;
  }
};

const parseApiDateTime = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  if (typeof value === "string") {
    if (value.includes("T")) {
      const parsed = m(value);
      return parsed.isValid() ? parsed.toDate() : null;
    }

    const brFormat = m(value, "DD/MM/YYYY HH:mm:ss", true);
    if (brFormat.isValid()) return brFormat.toDate();

    const brFormatShort = m(value, "DD/MM/YYYY HH:mm", true);
    if (brFormatShort.isValid()) return brFormatShort.toDate();
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/** Exibe instante UTC/API no fuso horário do navegador de quem acessa. */
export const changeToBrowserTimezone = (date) => {
  const parsedDate = parseApiDateTime(date);
  if (!parsedDate) return null;
  return m(parsedDate).format("DD/MM/YYYY HH:mm");
};

export const formatDateTimeInViewerTimezone = (
  value,
  pattern = "DD/MM/YYYY HH:mm",
) => {
  const parsedDate = parseApiDateTime(value);
  if (!parsedDate) return null;
  return m(parsedDate).format(pattern);
};

export const updateQueryStringParameter = (uri, key, value) => {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
};

export const getTime = (time) => {
  let data = new Date(time),
    hour = ("0" + data.getHours()).slice(-2).toString(),
    minutes = ("0" + data.getMinutes()).slice(-2).toString();
  // seconds = ("0" + data.getSeconds()).slice(-2).toString()

  return hour + ":" + minutes; // 12:54
};

export const formatedDate = (dt) => {
  let data = new Date(dt),
    dia = data.getUTCDate().toString(),
    diaF = dia.length === 1 ? "0" + dia : dia,
    mes = (data.getUTCMonth() + 1).toString(),
    mesF = mes.length === 1 ? "0" + mes : mes,
    anoF = data.getUTCFullYear(),
    hour = ("0" + data.getHours()).slice(-2).toString(),
    minutes = ("0" + data.getMinutes()).slice(-2).toString(),
    seconds = ("0" + data.getSeconds()).slice(-2).toString();

  return `${diaF}/${mesF}/${anoF}`; // 11/11/2019
};
export const get_farm_id_from_url = () => {
  let pathname = window.location.pathname;
  if (pathname.length <= 1) {
    return 0;
  }
  let farm_id = Number(pathname[1]);
  return isNaN(farm_id) ? 0 : farm_id;
};

export const isChildrenEmpty = (data, text, content) => {
  // return map of the component
  // or auxiliar text, case is empty
  const list = normalizeApiList(data);
  return list.length === 0 ? text : content;
};

export function normalizeApiList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}
export const secondsToFormateTime = (totalSeconds) => {
  let hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  let minutes = Math.floor(totalSeconds / 60);
  let seconds = totalSeconds % 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  return hours + ":" + minutes + ":" + seconds; // "5:39"
};

export const secondToMinute = (seconds) => {
  return (seconds / 60.0).toFixed(2);
};

// calculate distance between two points in kilometers
export function distance(lat1, lon1, lat2, lon2) {
  // haversine formula
  const toRadians = (degree) => (degree * Math.PI) / 180;

  const R = 6371; // Radius of the Earth in kilometers
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers

  return distance;
}

export function getApiErrorMessage(error, fallback = "") {
  if (!error) return fallback;

  const data = error.response && error.response.data;
  if (typeof data === "string" && data.trim()) {
    return data.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  }
  if (data && typeof data.detail === "string" && data.detail.trim()) {
    return data.detail.trim();
  }
  if (data && typeof data.error === "string" && data.error.trim()) {
    return data.error.trim();
  }
  if (data && typeof data === "object") {
    const values = Object.values(data).flat();
    const first = values.find((value) => typeof value === "string" && value.trim());
    if (first) return first.trim();
  }
  if (error.message && error.message.trim()) {
    return error.message.trim();
  }
  return fallback;
}
